import apollo from 'graphql/apollo';
import { resendVerificationEmailMutation } from 'graphql/mutations';

const resendVerificationEmail = async ({ email }) =>
  apollo.mutate({
    mutation: resendVerificationEmailMutation,
    variables: { email },
  });
export default resendVerificationEmail;
